import { render, staticRenderFns } from "./ProgramsCreate.vue?vue&type=template&id=9bfd8a72"
import script from "./ProgramsCreate.vue?vue&type=script&lang=js"
export * from "./ProgramsCreate.vue?vue&type=script&lang=js"
import style0 from "./ProgramsCreate.vue?vue&type=style&index=0&id=9bfd8a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports